import { render, staticRenderFns } from "./PhysicianList.vue?vue&type=template&id=0a23d78a&"
import script from "./PhysicianList.vue?vue&type=script&lang=ts&"
export * from "./PhysicianList.vue?vue&type=script&lang=ts&"
import style0 from "./PhysicianList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports